module.exports = {
      id: "hong kong-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#hong kong-usage",
      toString: function () {
        return this.url;
      }
    }